module.exports = __webpack_public_path__ + "static/media/auto.7746b7fd.svg";